module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-4-photo-4-4631ca803a2381843b03d304690b78c3.webp";